import styles from './AIWorkingIndicator.module.css';

interface AIWorkingIndicatorProps {
  /** What the AI is doing right now, in OurTake voice (e.g. "Polishing this recap…"). */
  label: string;
  /**
   * Compact variant drops the tinted pill background so the row can sit inline
   * inside an already-busy surface (e.g. the prompts bar).
   */
  compact?: boolean;
}

/**
 * Subtle, reusable in-flight cue for asynchronous AI work. Shown while a
 * background AI job (recap polish, adaptive prompts, narrative weave) is running
 * and the surface it belongs to will auto-update on the completion socket event.
 * Announced politely to assistive tech; the pulsing dots still under
 * prefers-reduced-motion.
 */
export function AIWorkingIndicator({ label, compact }: AIWorkingIndicatorProps) {
  return (
    <div
      class={`${styles.row} ${compact ? styles.compact : ''}`}
      role="status"
      aria-live="polite"
    >
      <span class={styles.dots} aria-hidden="true">
        <span class={styles.dot} />
        <span class={styles.dot} />
        <span class={styles.dot} />
      </span>
      <span class={styles.label}>{label}</span>
    </div>
  );
}
